var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          maxWidth: _vm.getMaxWidth,
          minWidth: _vm.getMinWidth,
          minHeight: "85vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_preview,
        callback: function($$v) {
          _vm.show_preview = $$v
        },
        expression: "show_preview"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_preview = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t(_vm.game_name)) + "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "q-pa-xs" }, [
              _c("p", { staticClass: "text-bold" }, [
                _vm._v(_vm._s(_vm.$t("game_preview")))
              ]),
              _c(
                "div",
                [
                  _c(
                    "q-carousel",
                    {
                      staticClass: "q-my-sm",
                      attrs: {
                        color: "primary",
                        easing: _vm.overshoot,
                        autoplay: _vm.autoplay,
                        height: "550px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "control-progress",
                          fn: function(carousel) {
                            return _c(
                              "q-carousel-control",
                              { attrs: { position: "top", offset: [260, 10] } },
                              [
                                _c("q-progress", {
                                  attrs: {
                                    percentage: carousel.percentage,
                                    stripe: "",
                                    color: "primary",
                                    animate: _vm.autoplay
                                  }
                                })
                              ],
                              1
                            )
                          }
                        }
                      ]),
                      model: {
                        value: _vm.slide,
                        callback: function($$v) {
                          _vm.slide = $$v
                        },
                        expression: "slide"
                      }
                    },
                    [
                      _vm._l(_vm.cards, function(card, index) {
                        return _c(
                          "q-carousel-slide",
                          {
                            key: index,
                            staticClass: "flex flex-center q-mb-lg bg-gray-1"
                          },
                          [
                            _c(
                              "q-card",
                              { staticClass: "card-style q-py-md" },
                              [
                                _c(
                                  "q-card-title",
                                  { staticClass: "row q-mx-md" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-subtitle1 flex justify-between"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.slide +
                                                1 +
                                                "/" +
                                                _vm.number_of_cards
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        ),
                                        card.correct !== null
                                          ? _c("q-icon", {
                                              attrs: {
                                                name: card.correct
                                                  ? "far fa-check"
                                                  : "far fa-times",
                                                color: card.correct
                                                  ? "positive"
                                                  : "negative"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c("q-card-main", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "q-body-2 q-my-lg q-mx-md text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(card.question.text) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]),
                                _c(
                                  "q-card-actions",
                                  { attrs: { align: "around" } },
                                  [
                                    _c(
                                      "q-btn",
                                      {
                                        attrs: { flat: "", color: "positive" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.sendAnswer(index, 1)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("true")))]
                                    ),
                                    _c(
                                      "q-btn",
                                      {
                                        attrs: { flat: "", color: "negative" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.sendAnswer(index, 0)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("false")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c(
                        "q-carousel-control",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.slide > 0,
                              expression: "slide > 0"
                            }
                          ],
                          staticClass: "text-white",
                          staticStyle: {
                            padding: "4px",
                            "border-radius": "4px"
                          },
                          attrs: {
                            slot: "control",
                            position: "bottom-left",
                            offset: [150, 160]
                          },
                          slot: "control"
                        },
                        [
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              color: "primary",
                              icon: "fas fa-arrow-left",
                              disable: _vm.slide >= _vm.number_of_cards
                            },
                            on: {
                              click: function($event) {
                                _vm.slide -= 1
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-carousel-control",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.slide < _vm.number_of_cards - 1,
                              expression: "slide < number_of_cards - 1"
                            }
                          ],
                          staticClass: "text-white",
                          staticStyle: {
                            padding: "4px",
                            "border-radius": "4px"
                          },
                          attrs: {
                            slot: "control",
                            position: "bottom-right",
                            offset: [150, 160]
                          },
                          slot: "control"
                        },
                        [
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              color: "primary",
                              icon: "fas fa-arrow-right",
                              disable: _vm.slide >= _vm.cards.length
                            },
                            on: {
                              click: function($event) {
                                _vm.slide += 1
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "col-10 q-mt-lg" },
                    [
                      _c("p", { staticClass: "text-bold q-mt-sm" }, [
                        _vm._v(_vm._s(_vm.$t("result")))
                      ]),
                      _c("q-slider", {
                        attrs: {
                          disable: "",
                          markers: "",
                          snap: "",
                          color: _vm.game_finished
                            ? _vm.getSliderColor()
                            : "blue-6",
                          min: 0,
                          max: _vm.number_of_cards
                        },
                        model: {
                          value: _vm.user_score,
                          callback: function($$v) {
                            _vm.user_score = $$v
                          },
                          expression: "user_score"
                        }
                      }),
                      _c("p", { staticClass: "q-mt-sm" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("correct_answers") +
                                ": " +
                                _vm.user_score +
                                " / " +
                                _vm.number_of_cards
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm.user_won
                        ? _c("p", [_vm._v(_vm._s(_vm.$t(_vm.success_message)))])
                        : _c("p", [_vm._v(_vm._s(_vm.$t(_vm.failure_message)))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-xs-12 q-mt-md" }, [
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("back") },
                    on: { click: _vm.resetGame }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }